import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import NoPostsIcon from '../../img/no_post_icon.svg';
import { getPostLanguage } from '../../services/authService';
import languages from '../../utils/languages';

const NoPosts = () => {
  const classes = useStyles();
  const webLanguage = getPostLanguage();
  const languageText = languages[webLanguage ? webLanguage : 'en'];

  return (
    <div align="center" width="100%">
      <Box bgcolor="white" height="450px">
        <Box pt="125px" align="middle"></Box>
        <Box mb={1}>
          <img
            className={classes.imageSize}
            src={NoPostsIcon}
            alt="not found"
          />
        </Box>
        <Typography variant="subtitle2">
          {languageText?.NO_POSTS_YET}
        </Typography>
        <Box mt={1} px={20}>
          <Typography display="block" align="center" variant="body1">
            {languageText?.SOMETHING_ON_YOUR_MIND}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

const useStyles = makeStyles({
  imageSize: {
    width: '80px',
    height: '80px',
  },
});
export default NoPosts;
